import { formatUrl } from '#app/utilities/formatUrl.js';

export const isValidPublicUrl = (url?: string) => {
  if (!url) {
    return false;
  }

  // 1. Verify string doesn't contain any illegal characters
  // See: http://tools.ietf.org/html/rfc3986#section-2
  if (/^([!#$&-;=?-[\]_a-z~]|%[\dA-Fa-f]{2})+$/.test(url) === false) {
    return false;
  }

  // 2. Verify string isn't relative URL
  if (url.startsWith('/')) return false;

  const newUrl = formatUrl(url);

  let hostname;
  try {
    hostname = new URL(newUrl).hostname;
  } catch {
    return false;
  }

  const hostnameParts = hostname.split('.');
  const isNotOnePartHostname =
    hostnameParts.filter((hostnamePart, index) =>
      // this is to allow for domains like x.com to pass this check, since the domain is only one character long it would otherwise fail.
      index === 0
        ? hostnamePart.trim().length >= 1
        : hostnamePart.trim().length > 1,
    ).length > 1;

  try {
    // exclude one part hostnames like localhost`, etc.
    return isNotOnePartHostname;
  } catch {
    return false;
  }
};
